import { PDPGoodsGroup } from '../graphql/related-product-recommend-group_types.2';

// https://croquis.atlassian.net/browse/DISPLAYUX-6356
// TODO: 서버 리소스 이슈로 FE 에서 셀렉티드 컬러 대응
export function convertColorToSelectedPdp(list: PDPGoodsGroup[], color?: string) {
  list.forEach((o) =>
    o.goods_carousel?.component_list?.forEach((v) => {
      if (v.discount_info) {
        v.discount_info.color = color ?? '#FF4C34';
      }
    }),
  );
}
